import React from 'react';
import { Text, ScrollView, View } from 'react-native';
import config from '../config';
import i18n from '../util/i18n';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { getSong } from '../services/song.service';
import api from '../services/axios.service';

const axios = api;

i18n.locale = navigator.language;


class Answers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            songId: '',
            song: null,
            answers: [],
            mqttStatus: ''
        };

        // Connect to MQTT broker here
        // generate random string for client id
        let clientId = Math.random().toString(36).substring(7);
        // this.client = new Paho.MQTT.Client(config.mqtt.host, clientId);
        let url = `${config.mqtt.host}`;
        this.client = new Paho.MQTT.Client(url, clientId);
        this.client.onConnectionLost = this.onConnectionLost;
        this.client.onMessageArrived = this.onMessageArrived;
        this.client.connect({
            useSSL: false,
            // userName:config.mqtt.user,
            // password:config.mqtt.pass,
            onSuccess: this.onConnect,
            onFailure: this.onFailure
        });
    }


    onConnect = () => {
        this.setState({ mqttStatus: i18n.t('connected_to_mqtt_broker') });
    }

    onFailure = (responseObject) => {
        this.setState({ mqttStatus: i18n.t('connection_to_mqtt_broker_failed') });
        console.log("Connection to MQTT Broker Failed: ", responseObject.errorMessage);
    }

    onConnectionLost = (responseObject) => {
        if (responseObject.errorCode !== 0) {
            this.setState({ mqttStatus: i18n.t('connection_lost') });
            console.log("Connection Lost: ", responseObject.errorMessage);
        }
    }

    onMessageArrived = (message) => {
        let messageJson = JSON.parse(message.payloadString);
        if (!messageJson.songId) {
            return;
        }
        this.setState({ songId: messageJson.songId });
        this.getSongDetails(messageJson.songId);
        this.getAnswersBySongId(messageJson.songId);
        
    }

    async componentDidMount() {

        this.intervalID = setInterval(async () => {
            if (this.state.songId != '') {
                await this.getAnswersBySongId(this.state.songId);
            } else {
                this.setState({ answers: [] });
            }
        }, 5000); // Fetches every 5 seconds
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    onConnect = () => {
        console.log("Connected to MQTT Broker!");
        this.client.subscribe(config.mqtt.topic);
        this.setState({ mqttStatus: 'connected' });
    }

    getSongDetails = async (songId) => {
        let song = await getSong(songId);
        this.setState({ song: song.song });
    }


    getAnswersBySongId = async (songId) => {
        let response = await axios.get(`/answers?songId=${songId}`);
        this.setState({ answers: response.data.answers });
    }


    render() {

        return (
            <ScrollView contentContainerStyle={{ flexGrow: 1, margin: 10 }}>
                <Text style={{ fontSize: 10, margin: 10, textAlign: 'center' }}>{i18n.t('mqtt_status')} {': ' + this.state.mqttStatus}</Text>

                <Text style={{ fontSize: 30, fontWeight: 'bold', margin: 10, textAlign: 'center' }}>{i18n.t('answers')}</Text>
                
                {(this.state?.song) ? (
                    <Text style={{ fontSize: 20, fontWeight: 'bold', margin: 10, textAlign: 'center' }}>{i18n.t('song_id')} {': ' + this.state?.song?.sl_no ?? ''} </Text>
                ) : null}


                <View>
                    <TableContainer component={Card} sx={{ mt: 2 }}>
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{i18n.t('group_id')}</TableCell>
                                    <TableCell>{i18n.t('artist')}</TableCell>
                                    <TableCell>{i18n.t('release')}</TableCell>
                                    <TableCell>{i18n.t('movie')}</TableCell>
                                    <TableCell>{i18n.t('language')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(this.state.answers.length > 0) ? this.state.answers.map((row, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell size='small'>{row.group_id}</TableCell>
                                            <TableCell size='small'>{row.is_correct_artist ? '' : row.artist}</TableCell>
                                            <TableCell size='small'>{row.is_correct_release ? '' : row.release}</TableCell>
                                            <TableCell size='small'>{row.is_correct_movie ? '' : row.movie}</TableCell>
                                            <TableCell size='small'>{row.is_correct_language ? '' : row.language}</TableCell>
                                        </TableRow>
                                    )
                                }) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </View>

            </ScrollView>
        );
    }

}

export default Answers;
